import React, { createRef, useEffect, useState } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";

import { PAGES } from "constants/pages";
import { PatientOverview } from "pages/PatientOverview";
import { VideoReview } from "pages/VideoReview/VideoReview";
import { PatientDetails } from "pages/PatientDetails/PatientDetails";
import ProtectedRoute from "pages/auth/ProtectedRoute";
import InviteUser from "pages/auth/InviteUser";
import { AuthContext, getRoleData } from "../contexts/authContext";
import { USER_GROUPS } from "constants/roles";
import { ClinicAdminOverview } from "pages/ClinicAdmin/ClinicAdminOverview";
import ClinicOverview from "pages/ClinicOverview";
import Profile from "../pages/auth/Settings/Profile";
import { AuthStatus, IAuth } from "interfaces/IAuth";
import AtheleteOverview from "../pages/AthleteOverview/AthleteOverview";
import InviteAthlete from "../pages/AthleteOverview/InviteAthlete";
import LeaderboardPage from "../pages/Report/LeaderboardPage";
import SideBySidePage from "../pages/Report/SideBySide";
import { CreateTemplate } from "../pages/ClinicOverview/components/CreateTemplate";
import SuperAdminOverview from "pages/SuperAdmin/SuperAdminOverview";
import SubscriptionSuccess from "components/SubscriptionSuccess/SubscriptionSuccess";

const SubscriptionCancel = () => {
  return <div>Subscription Cancel</div>;
};

export const historyRef: any = createRef();
export const Routes = () => {
  const history = useHistory();
  const [roles, setRoles] = useState<string[]>([]);
  const { authStatus }: IAuth = React.useContext(AuthContext);

  historyRef.current = history;
  useEffect(() => {
    getRoles();
  }, []);
  const getRoles = async () => {
    const roles = await getRoleData();
    setRoles(roles ?? []);
  };

  if (authStatus !== AuthStatus.SignedIn) {
    return null;
  }

  const isClinician =
    roles.includes(USER_GROUPS.CLINIC_ADMIN) ||
    roles.includes(USER_GROUPS.CLINIC_ASSISTANT) ||
    roles.includes(USER_GROUPS.CLINIC_TEAM_LEAD) ||
    roles.includes(USER_GROUPS.CLINICIAN) ||
    roles.includes(USER_GROUPS.CLINIC_TEAM_MEMBER);

  const isSuperAdmin = roles.includes(USER_GROUPS.SUPER_ADMIN);

  /** Clinitian part is hidden. Return it back later */
  return (
    <>
      <Switch>
        {isSuperAdmin && (
          <>
            <ProtectedRoute
              exact
              path={PAGES.homeScreen}
              component={SuperAdminOverview} /* superadminoverview */
            />{" "}
            {/* <ProtectedRoute exact path={PAGES.homeScreen} component={InviteUser} /> */}
            <ProtectedRoute
              exact
              path={PAGES.clinicOverview}
              component={ClinicOverview}
            />
            <ProtectedRoute
              exact
              path={PAGES.athleteOverview}
              component={AtheleteOverview}
            />
            <ProtectedRoute
              exact
              path={PAGES.userConfig}
              component={InviteUser}
            />
            <ProtectedRoute
              exact
              path={PAGES.userProfile}
              component={Profile}
            />
            {/* this one is for notes v2 */}
            <ProtectedRoute
              exact
              path={PAGES.patientDetails}
              component={PatientDetails}
            />
          </>
        )}

        {isClinician && (
          <>
            <ProtectedRoute
              exact
              path={PAGES.homeScreen}
              component={ClinicAdminOverview}
            />
            <ProtectedRoute path={PAGES.userProfile} component={Profile} />
            <ProtectedRoute
              exact
              path={PAGES.patientDetails}
              component={PatientDetails}
            />
            <ProtectedRoute
              exact
              path={PAGES.videoReview}
              component={VideoReview}
            />
            <ProtectedRoute
              exact
              path={PAGES.patientOverview}
              component={PatientOverview}
            />
            <ProtectedRoute
              exact
              path={PAGES.createTemplate}
              component={CreateTemplate}
            />
            <ProtectedRoute
              exact
              path={PAGES.editTemplate}
              component={CreateTemplate}
            />
          </>
        )}

        <ProtectedRoute
          exact
          path={PAGES.homeScreen}
          component={PatientOverview}
        />
        <ProtectedRoute
          exact
          path={"/invite-athlete"}
          component={InviteAthlete}
        />
        <ProtectedRoute
          exact
          path={"/subscription/success"}
          component={SubscriptionSuccess}
        />
        <ProtectedRoute
          exact
          path={"/subscription/cancel"}
          component={SubscriptionCancel}
        />
        <ProtectedRoute
          exact
          paid
          path={"/report/leaderboard"}
          component={LeaderboardPage}
        />
        <ProtectedRoute
          exact
          paid
          path={"/report/side-by-side"}
          component={SideBySidePage}
        />
        <ProtectedRoute
          exact
          path={PAGES.videoReview}
          component={VideoReview}
        />
        <ProtectedRoute
          exact
          path={PAGES.patientOverview}
          component={PatientOverview}
        />
        <ProtectedRoute
          exact
          path={PAGES.patientDetails}
          component={PatientDetails}
        />
        <ProtectedRoute path={PAGES.userConfig} component={InviteUser} />
        <ProtectedRoute path={PAGES.userProfile} component={Profile} />
        <ProtectedRoute
          path={PAGES.createTemplate}
          component={CreateTemplate}
        />
        <ProtectedRoute path={PAGES.editTemplate} component={CreateTemplate} />

        <Route path="*" component={() => <Redirect to="/" />} />
      </Switch>
    </>
  );
};
